import { Injectable } from '@angular/core';
import { ModuleConfig, ModuleConfigService } from '../../../common/services/module-config/module-config.service';
import { HolUTCDisplay } from '../../../common/enums/hol-utc-display.enum';

@Injectable({
  providedIn: 'root',
})
export class OccModuleConfigService extends ModuleConfigService {
  public constructor() {
    super();
    this.config.localHours = false;
    this.config.utcDisplay = HolUTCDisplay.LOCAL_IF_READONLY;
    this.config.showLinkToFlightOcc = true;
    this.config.moduleName = 'occ';
    this.config.forceEventChecklistActivation = false;
    this.config.canCreateItemsFromLogbook = true;
    this.config.canCreateTags = false;
    this.config.logbooksOrder = 1;
    this.config.eventsOrder = 2;
    this.config.decisionsOrder = 3;
    this.config.flightsOrder = 4;
    this.config.canActivateEclModule = true;
    this.config.translateKey = 'OCC';
    this.config.canEditNi = false;
    this.config.canOpenFlight = false;
    this.config.activateEventNotification = true;
    this.config.forceEventNotification = false;
    this.config.rootPath = 'occ';
    this.config.displayToGoc = true;
    this.config.activateTODO = true;
  }
}
